import { Link, useLocation } from 'react-router-dom';
import { Tab, Tabs } from '../../navigation/Tabs';
import { Typography } from '../../typography/Typography';
import { BusinessManagementTabsBox } from './styles';
import type { IBusinessManagementTabsProps } from './types';

export const BusinessManagementTabs: React.FC<IBusinessManagementTabsProps> = ({
    tabs,
    onTabClick,
}) => {
    const { pathname } = useLocation();

    return (
        <BusinessManagementTabsBox ml={{ xs: 2, sm: 0 }}>
            <Tabs value={pathname} onChange={onTabClick} overflow="visible">
                {tabs.map((tabItem, idx) => (
                    <Tab
                        key={tabItem.value}
                        as={Link}
                        py={2}
                        px={0}
                        ml={idx > 0 ? 2 : 0}
                        replace
                        to={tabItem.value}
                        value={tabItem.value}
                        textDecoration="none"
                    >
                        <Typography
                            color="inherit"
                            variant="caption"
                            weight="bold"
                            textAlign="center"
                            textTransform="uppercase"
                            letterSpacing="0.7px"
                        >
                            {tabItem.label}
                        </Typography>
                    </Tab>
                ))}
            </Tabs>
        </BusinessManagementTabsBox>
    );
};
